import templateUrl from 'emun.salesrep/salesrep-activities.htm'
import activityConfig from 'emun.activity/activity.config'

class SalesRepActivitiesController {
    constructor($rootScope, createAutoQuery, $window) { 
        var scope = this;
        //this.prompt = retailerPrompt;
        const $ctrl = this;
        this.activities = createAutoQuery({
            url: 'QueryActivitiesJoin.json?dateRange=Last30Next30&repId=' + this.salesrep.id,
            orderBy: '-StartDate',
            autoLoad: true,
            pageSize: 10,
            scrollTop: false
        })
        $rootScope.$on('activitySaved', function() {
            scope.activities.load(true);
        });
        $rootScope.$on('activityDeleted', function() {
            scope.activities.load(true);
        });
		$ctrl.activityConfig = activityConfig;
    }
    //edit(){return this.prompt.edit(this.customer).then(() => this.container.query.load(true));}
}

let SalesRepActivities = {
    bindings: {
        salesrep: '<'
    },
    //require: {
    //    container: '^salesrepDashboard'
    //},
    controller: SalesRepActivitiesController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.salesrep').component('salesrepActivities', SalesRepActivities);

export default SalesRepActivities